import { BeketPassengersValue } from 'entities/beket/models/form-passengers'
import beketFormPassengersStore from 'entities/beket/models/form-passengers/form-passengers-state'

export const preparePassengerInfo = (data: BeketPassengersValue) => {
  if (!data) return null

  const citizenship = beketFormPassengersStore.seatsResponse?.countries?.find(
    (citizenship) => citizenship.id === parseInt(data.citizenship || ''),
  )

  return {
    firstName: data.firstName,
    lastName: data.lastName,
    // dateOfBirth: data.dateOfBirth,
    citizenship: citizenship?.name,
    serialDocuments: data.serialDocuments,
    tariff: data.tariff,
  }
}
